module.exports = __webpack_public_path__ + "img/av042.cf284e57.png";